import React from "react";
import { enviroment } from "../../../enviroment";

// LAV 8 (Clarity: 102/69 clicks on a logo/design row that open nothing): the
// SKU/MUL/title spans in the list rows swallow the click that the surrounding
// ListItemFrame turns into "open details". With the list fixes on they let
// it through; off = today's stopPropagation, byte for byte.
export function rowTextClickProps(): {
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
} {
  if (enviroment.uxListFixesEnabled) return {};
  return { onClick: (e) => e.stopPropagation() };
}
